export default "__VITE_ASSET__3355f267__"